if (!customElements.get('store-pickup-inline')) {
  class StorePickupInline extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
    }

    onVariantChange(event) {
      const sectionId = event?.data?.sectionId;
      if (sectionId && sectionId !== this.dataset.sectionId) return;

      const variant = event?.data?.variant;
      if (!variant?.id) {
        this.setVisible(false);
        return;
      }

      this.dataset.variantId = variant.id;
      this.fetchPickup(variant.id);
    }

    fetchPickup(variantId) {
      let rootUrl = this.dataset.rootUrl || '/';
      if (!rootUrl.endsWith('/')) {
        rootUrl = `${rootUrl}/`;
      }

      fetch(`${rootUrl}variants/${variantId}/?section_id=product-store-pickup`)
        .then((response) => response.text())
        .then((text) => {
          const section = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
          const content = section?.querySelector('[data-store-pickup-content]');
          const destination = this.querySelector('[data-pickup-content]');

          if (!content || content.dataset.available !== 'true' || !destination) {
            this.setVisible(false);
            return;
          }

          destination.innerHTML = content.innerHTML;
          this.setVisible(true);
        })
        .catch(() => {
          this.setVisible(false);
        });
    }

    setVisible(isVisible) {
      this.toggleAttribute('hidden', !isVisible);
    }
  }

  customElements.define('store-pickup-inline', StorePickupInline);
}
